import React from 'react';
import { useSidebarStore } from '@atlassian/jira-software-releases-issue-sidebar-use-sidebar-store/src/controllers/index.tsx';
import { Issue } from './issue/index.tsx';

const CLOSED = 'CLOSED' as const;
const SHOWING_ISSUE = 'SHOWING_ISSUE' as const;

const SidebarStatuses = {
	CLOSED,
	SHOWING_ISSUE,
} as const;

export const SidebarContent = (): React.JSX.Element | null => {
	const [sidebarState, sidebarActions] = useSidebarStore();
	const onClose = sidebarActions.close;
	switch (sidebarState.status) {
		case SidebarStatuses.CLOSED:
			return null;
		case SidebarStatuses.SHOWING_ISSUE:
			return <Issue issueKey={sidebarState.issueKey} onClose={onClose} />;
		default:
			// prettier-ignore
			// @ts-expect-error - TS2339 - Property 'status' does not exist on type 'never'.
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			(sidebarState.status as never);
			throw Error('Unhandled sidebar status');
	}
};
